import type { ReportingLevel } from "./types";

export const reportingQueryKeys = {
  all: ["reporting"] as const,

  aggregated: (segment: ReportingLevel, params: Record<string, unknown>) =>
    [...reportingQueryKeys.all, segment, "aggregated", params] as const,

  integrationAggregated: (integrationName: string, params: Record<string, unknown>) =>
    [...reportingQueryKeys.all, "integration", integrationName, "aggregated", params] as const,

  aggregatedMetrics: (segment: ReportingLevel, params: Record<string, unknown>) =>
    [...reportingQueryKeys.all, segment, "aggregatedMetrics", params] as const,

  filterCounts: (segment: ReportingLevel, params: Record<string, unknown>) =>
    [...reportingQueryKeys.all, segment, "filterCounts", params] as const,

  integrations: (
    tenantId: string | undefined,
    clientId: string | undefined,
    isActive?: boolean | null
  ) => [...reportingQueryKeys.all, "general", "integrations", tenantId, clientId, isActive] as const,
};
